import React, { useState } from 'react';
import { useGame } from '@domain/game.selection/game.selection.hook';
import GameMenu from '@components/app.chrome/game.menu';
import { GameLogo } from '@components/app.chrome/game.menu.button.styles';

const GameMenuButton = () => {
  const game = useGame();

  const [gameMenuAnchorEl, setGameMenuAnchorEl] = useState<Element | null>(null);

  const openGameMenu = (event: React.MouseEvent<HTMLElement, MouseEvent>) => setGameMenuAnchorEl(event.currentTarget);
  const closeGameMenu = () => setGameMenuAnchorEl(null);

  return (
    <>
      <GameLogo src={game.logoImgSrc} alt={game.title} aria-label='game menu' aria-controls='game-menu' onClick={openGameMenu} />
      <GameMenu anchorEl={gameMenuAnchorEl} onClearAnchor={closeGameMenu} />
    </>
  );
};

export default GameMenuButton;
